import React from 'react';
import "./heroComponentv2.css";

export default function HeroComponentv2({ data }) {
  const { 
    title, 
    subtitle, 
    buttonText, 
    imgSrc, 
    buttonLink,
    llamaWatching,
    llamaReading
  } = data;

  const handleButtonClick = () => {
    window.open(buttonLink, '_blank', 'noopener,noreferrer');
  };

  // Helper function to render the title with highlighted words
  const renderTitle = (title) => {
    // Define the words to be highlighted
    const highlightWords = ["Startups", "Enterprise", "Zapier"];
    // Create a regex that matches any of the highlight words
    const regex = new RegExp(`(${highlightWords.join("|")})`, "g");
    // Split the title into parts, keeping the matched words
    const parts = title.split(regex);

    return parts.map((part, index) =>
      highlightWords.includes(part) ? (
        <span key={index} className="header-highlight">{part}</span>
      ) : (
        part
      )
    );
  };

  return (
    <div className="herov2-wrapper">
      <div className="herov2-header">{renderTitle(title)}</div>
      <div className="herov2-subtext">{subtitle}</div>

      <button className="herov2-button" onClick={handleButtonClick}>
        {buttonText}
      </button>
      
      <div className="herov2-img-container">
        <img className="herov2-img" src={imgSrc} alt="Hero" />
        
        <div className="herov2-llama-watch-container">
          <img
            className="herov2-llama-watch"
            src={llamaWatching}
            alt="Watching Llama"
          />
        </div>
        
        <div className="herov2-llama-watch-container herov2-llama-watch-container-left">
          <img
            className="herov2-llama-watch"
            src={llamaReading}
            alt="Reading Llama"
          />
        </div>
      </div>
    </div>
  );
}
